import _get from 'lodash/get'
import { baseRequest, consumerRequest } from '.'

export const linkTicket = async ({ eventId, ticketTypeId, categoryKey }) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/events/main/link_ticket_type`, {
    ticketTypeId,
    categoryKey,
  })
  return _get(res, 'data')
}

export const unlinkTicket = async ({ eventId, ticketTypeId, categoryKey }) => {
  const res = await baseRequest.delete(`event/${eventId}/seats-io/events/main/unlink_ticket_type`, {
    data: {
      ticketTypeId,
      categoryKey,
    },
  })
  return _get(res, 'data')
}

export const fetchSeatsIoEvent = async eventId => {
  const res = await baseRequest.get(`event/${eventId}/seats-io/events/main`)
  return _get(res, 'data.data.attributes')
}

export const fetchSeatsIoData = async eventId => {
  const res = await baseRequest.get(`event/${eventId}/seats-io/events/main/configuration`)
  return _get(res, 'data.data.attributes')
}

export const reserveSeatsIo = async (eventId, seats) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/events/main/reserve_for_guest`, {
    seats,
  })
  return _get(res, 'data.data.attributes')
}

export const fetchSeatsIoMapsByVenue = async venueId => {
  const res = await baseRequest.get(`venue/${venueId}/seats-io/charts`)
  return _get(res, 'data.data.attributes')
}

export const fetchSeatsIoConfiguration = async () => {
  const res = await baseRequest.get(`event/seats-io/events/configuration`)
  return _get(res, 'data.data.attributes')
}

export const setSeatsIoData = async ({ eventId, chartKey, chartName }) => {
  const res = await baseRequest.post(`event/${eventId}/seats-io/events`, {
    settings: {
      chartKey,
      chartName,
    },
  })
  return _get(res, 'data.data.attributes')
}

export const createChart = async data => {
  const res = await consumerRequest.post(`v1/seats-io/charts`, data)
  return _get(res, 'data.data.attributes')
}

export const createTag = async (chartKey, tag) => {
  const res = await consumerRequest.post(`v1/seats-io/charts/${chartKey}/tags/${tag}`)
  return _get(res, 'data.data.attributes')
}

export const deleteMap = async eventId => {
  const res = await baseRequest.delete(`event/${eventId}/seats-io/events/main`)
  return _get(res, 'data.data.attributes')
}